import { Stack } from "@mantine/core"
import { LabelWithTooltip, TextInput } from "@tfg/ui"

import { getNestedError } from "~/pages/Admin/components/Fields/utils"
import { FormFieldConfig } from "~/pages/Admin/components/TypesForm"
import { errorCodes } from "~/pages/SupplierPortal/TraceabilityRequests/components/ZodCustomErrorMap"

export const TextInputField = (
  fields: FormFieldConfig,
  form: any,
  error: keyof errorCodes | undefined,
  translations: errorCodes | undefined,
  inputProps?: React.ComponentProps<typeof TextInput>
) => {
  const errors = getNestedError(form.errors, fields.name)
  return (
    <Stack gap="var(--mantine-spacing-xxs)">
      {fields.tooltip && (
        <LabelWithTooltip
          label={fields.label}
          hoverHelperText={fields.tooltip}
          justify="space-between"
          fw={600}
          withAsterisk={fields.required ?? false}
        />
      )}
      <TextInput
        key={fields.name}
        labelProps={{
          fz: "xs",
          fw: 600,
        }}
        label={!fields.tooltip ? fields.label : undefined}
        placeholder={fields.placeholder}
        {...form.getInputProps(fields.name)}
        onChange={(value) => {
          form.setFieldValue(fields.name, value.currentTarget.value)
          form.validateField(fields.name)
        }}
        onInput={() => {
          form.validateField(fields.name)
        }}
        size="xs"
        classNames={fields.customClass}
        error={errors || (error && translations?.[error])}
        disabled={fields.disabled}
        {...inputProps}
      />
    </Stack>
  )
}
